import { render, staticRenderFns } from "./dataone.vue?vue&type=template&id=1968988c&scoped=true&"
import script from "./dataone.vue?vue&type=script&lang=js&"
export * from "./dataone.vue?vue&type=script&lang=js&"
import style0 from "./dataone.vue?vue&type=style&index=0&id=1968988c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1968988c",
  null
  
)

export default component.exports